import type { FC, PropsWithChildren, ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import type { TextProps } from 'react-native-paper';

import type { NavigationItemProps } from '@/navigation/types/navigation';
import { Row } from '@/shared/components/layout/Row';
import { Title } from '@/shared/components/text/Title';
import type { SVGComponent } from '@/types';

import { SectionNavigationButton } from './SectionNavigationButton';

const styles = StyleSheet.create({
  content: { gap: 12 },
  row: {
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 8
  }
});

type Props = {
  title: string;
  testId?: string;
  titleColor?: string;
  titleFont?: string;
  titleVariant?: TextProps<string>['variant'];
  icon?: SVGComponent;
  iconColor?: string;
  end?: ReactNode;
} & Partial<NavigationItemProps> &
  PropsWithChildren;

export const SectionContent: FC<Props> = ({
  title,
  testId,
  titleColor,
  titleFont,
  titleVariant,
  icon,
  iconColor,
  children,
  end,
  ...navigationProps
}) => (
  <View testID={testId}>
    <Row style={styles.row}>
      <Title
        color={titleColor}
        font={titleFont}
        variant={titleVariant}
        icon={icon}
        iconColor={iconColor}
      >
        {title}
      </Title>
      {navigationProps.screen !== undefined && (
        <SectionNavigationButton
          {...(navigationProps as NavigationItemProps)}
        />
      )}
      {end}
    </Row>
    <View style={styles.content}>{children}</View>
  </View>
);
